/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceVisibilityListResponse {
    getFixupPrototypeFunction() { return ResourceVisibilityListResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceVisibilityListResponse>): ResourceVisibilityListResponse {
        let obj = Object.assign(new ResourceVisibilityListResponse(), model);
        ResourceVisibilityListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceVisibilityListResponse>): ResourceVisibilityListResponse {
        if (!model) return null;
        return ResourceVisibilityListResponse.newInstance(<ResourceVisibilityListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceVisibilityListResponse) {
        if (!obj) return;

        models.ResourceVisibilityListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceVisibilityListResponse): boolean {
        Object.setPrototypeOf(obj, ResourceVisibilityListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.resource_list_data) {
            for (let val of this.resource_list_data) {
                models.PostureResourceListModel.fixupPrototype(val);
            }
        }
    }

    /**
     * count details
     */
    total_count: number;

    /**
     * List of account wise count data
     */
    resource_list_data: Array<models.PostureResourceListModel>;

}
